module.exports = __webpack_public_path__ + "static/media/panCard.bfb79172.jpg";